import React from "react";
import { Container, Row, Col, Spinner } from "reactstrap";
import { connect } from "react-redux";
import '../../style/PageView.css';
import { renderElement } from "../../../../../helpers/renderElement";

class PageViewContent extends React.Component {
  render() {
    const { pageElements } = this.props.page;
    const { template } = this.props;
    
    return (
      <div className="animated fadeIn">
          {pageElements &&
            pageElements.filter(el => el.parentId === null).map((el, index) => {
              return (
                <React.Fragment key={index}>
                  <Row
                    style={{
                      width: "100%",
                      display: "inline-flex",
                      marginLeft: '0px',
                      backgroundColor: 'unset'
                    }}
                  >
                    <Col
                      style={{
                        padding: '0px',
                        width: "100%",
                        display: "inline-flex",
                      }}
                    >
                      <Col
                        style={{
                          padding: '0px',
                          maxWidth: "100%",
                          backgroundColor: "unset"
                        }}
                      >
                        {renderElement(el.type, el)}
                      </Col>
                    </Col>
                  </Row>
                </React.Fragment>
              );
            })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    elements: state.element.elements,
    alert: state.alert,
    page: state.page,
    template: state.template.template
  };
}

export default connect(mapStateToProps)(PageViewContent);
